/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const RewindLargeIcon = ({ width = 24, height = 28, color = '#fff', children, ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 24 28' fill={color} {...props} xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.35339 0.979821C4.54865 1.17508 4.54865 1.49167 4.35339 1.68693L1.87361 4.16671H11.9998C18.5352 4.16671 23.8332 9.46467 23.8332 16C23.8332 22.5354 18.5352 27.8334 11.9998 27.8334C5.46447 27.8334 0.166504 22.5354 0.166504 16C0.166504 15.7239 0.390362 15.5 0.666504 15.5C0.942646 15.5 1.1665 15.7239 1.1665 16C1.1665 21.9831 6.01675 26.8334 11.9998 26.8334C17.9829 26.8334 22.8332 21.9831 22.8332 16C22.8332 10.017 17.9829 5.16671 11.9998 5.16671H1.87361L4.35339 7.64649C4.54865 7.84175 4.54865 8.15833 4.35339 8.35359C4.15813 8.54886 3.84155 8.54886 3.64628 8.35359L0.312951 5.02026C0.117688 4.825 0.117688 4.50842 0.312951 4.31315L3.64628 0.979821C3.84155 0.784558 4.15813 0.784558 4.35339 0.979821Z'
    />
    <text x='48%' y='58%' fontSize={12} dominantBaseline='middle' textAnchor='middle'>
      {children}
    </text>
  </svg>
);

export default RewindLargeIcon;
